import { Reveal } from "@components/ui";

const features = [
  {
    number: 1,
    title: "Smart Metering Technology",
    description:
      "We use the latest generation of remote smart meters for accurate billing. Real-time consumption monitoring, No manual reading errors, Faster billing cycles, Instant alerts for abnormalities",
  },
  {
    number: 2,
    title: "Transparent & Fair Billing",
    description:
      "We believe in simple, honest billing. No hidden charges, Clear breakdown on every invoice, AED 20 billing fee + AED 25 smart meter connection (one time), Full VAT compliance with FTA",
  },
  {
    number: 3,
    title: "24/7 Emergency Support (800-GAZ)",
    description:
      "Your safety is our priority. We provide around-the-clock emergency response with 60-120 minute SLA, depending on location.",
  },
  {
    number: 4,
    title: "Certified Safety Standards (DCD & ESMA)",
    description:
      "Every GAZ installation follows strict safety protocols approved by: Dubai Civil Defense (DCD), ESMA (Emirates Standard), UAE Fire & Life Safety Code. Our technicians are fully licensed and trained.",
  },
  {
    number: 5,
    title: "Fast Connection & Reliable Supply",
    description:
      "We provide speedy new connections with minimal disruption. Our systems are built for 99.5% supply availability, meeting international reliability benchmarks.",
  },
  {
    number: 6,
    title: "Comprehensive Customer Portal",
    description:
      "Manage your entire account online: View bills, Pay online, Submit meter readings, Track consumption, Open service requests. Available 24/7 from any device.",
  },
  {
    number: 7,
    title: "Affordable Rates & Flexible Solutions",
    description:
      "Our pricing is always competitive and customer-friendly (AED 35/m\u00B3). Special packages available for: developers, commercial kitchens, hotels & F&B businesses, owner associations",
  },
  {
    number: 8,
    title: "Trusted by Developers Across the UAE",
    description:
      "We support residential towers, retail centers, hospitality venues, and communities. GAZ is part of the Contra Group of Companies, enhancing our financial strength and operational expertise.",
  },
];

export function WhatMakesDifferentSection() {
  return (
    <section className="w-full bg-white py-12 md:py-16 lg:py-[120px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto">
        {/* Header */}
        <Reveal>
          <div className="flex flex-col items-center text-center mb-10 md:mb-14 lg:mb-16">
            <span className="inline-block px-4 py-1.5 rounded-full bg-[#122d63]/[0.08] text-[#122d63] text-sm font-medium mb-4">
              Our Strengths
            </span>
            <h2 className="text-[28px] md:text-[44px] lg:text-[54px] font-semibold text-[#090d2c] tracking-[-0.04em] leading-[1.1] font-albert-sans">
              What Makes GAZ Different
            </h2>
            <p className="mt-3 text-[18px] md:text-[22px] lg:text-[28px] text-[rgba(10,14,46,0.75)] tracking-[-0.04em] font-albert-sans">
              Discover what stands us at GAZ out
            </p>
          </div>
        </Reveal>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => (
            <Reveal key={feature.number}>
              <div className="group relative overflow-hidden bg-white rounded-[24px] border border-[rgba(98,99,108,0.2)] p-6 hover:shadow-[0_4px_20px_rgba(0,0,0,0.08)] hover:border-[#e8e9ed] transition-all duration-300 h-full">
                {/* Watermark number */}
                <span className="absolute top-4 right-6 text-[64px] font-bold text-[#122d63]/[0.04] leading-none select-none pointer-events-none">
                  {feature.number}
                </span>

                {/* Numbered circle */}
                <div className="w-10 h-10 rounded-full bg-[#122d63]/[0.08] flex items-center justify-center mb-4">
                  <span className="text-[#122d63] text-sm font-semibold">
                    {String(feature.number).padStart(2, "0")}
                  </span>
                </div>

                <h3 className="text-[20px] md:text-[24px] font-semibold text-[#090d2c] tracking-[-0.04em] font-albert-sans mb-3">
                  {feature.title}
                </h3>
                <p className="text-[16px] md:text-[20px] text-[rgba(10,14,46,0.75)] tracking-[-0.04em] font-albert-sans leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
